// extracted by mini-css-extract-plugin
export var modalCloseButton = "ImageModal-module--modalCloseButton--mg7JQ";
export var modalContent = "ImageModal-module--modalContent--sQtOn";
export var modalImage = "ImageModal-module--modalImage--TwydQ";
export var modalOverlay = "ImageModal-module--modalOverlay--SH+aE";